import { importBook } from '~/utils/time_off_export_utils';
import api from '~/api';

/**
 * Parses the "row.amount" field and returns it as a number
 * of seconds. If a number of seconds can't be parsed from
 * the row's amount, "invalid" is returned - which in turn
 * triggers an error in our server-side validations.
 */
const parseAmount = (row) => {
  try {
    const rowAmount = String(row.amount);

    return TimeInput.parse_duration(rowAmount).asSeconds();
  } catch (err) {
    return 'invalid';
  }
};

export async function processFile(file, preImportSummaryPath, csvRowLimit, intAmount = false) {
  let csvRows = await importBook(file);

  if (csvRows.length > csvRowLimit) {
    /**
     * This validation exists server-side too, performing the
     * validation client-side provides the customer with faster
     * feedback, and avoids a request that could potentially process
     * a lot of rows (at least more than "csvRowLimit").
     */
    throw new Error(
      `There was an error validating the CSV file:\n` + `A maximum of ${csvRowLimit} rows can be processed at a time`,
    );
  }

  let resultError = false;

  try {
    csvRows = csvRows.map((row) => {
      const amount = parseAmount(row);

      return { ...row, amount: intAmount ? parseInt(amount, 10) : amount };
    });

    const result = await api.post(preImportSummaryPath, { csv_rows: csvRows });

    if (result.success) {
      return result.results;
    }

    resultError = true;
    throw new Error(`There was an error validating the CSV file:\n${result.errors[0]}`);
  } catch (err) {
    if (resultError) {
      throw err;
    } else {
      throw new Error('There was an unexpected error processing the CSV file');
    }
  }
}

export default {
  processFile,
};
